import { SeriesCombination, SearchResponse } from "interfaces/dataInterfaces"
import { coreApi } from "./coreApi"

export const seriesCombination = coreApi.injectEndpoints({
  endpoints: builder => ({
    getSeriesCombination: builder.query<
      SearchResponse<SeriesCombination>,
      {
        admCode?: number
        skip: number
        take: number
        market?: number
        comodity?: number
        query?: string
        commodityUnitId?: number
        currencyId?: number
        priceTypeId?: number
        seriesCombinationVisibility?: boolean | string
      }
    >({
      query: ({
        admCode,
        skip,
        take,
        market,
        comodity,
        query,
        commodityUnitId,
        currencyId,
        priceTypeId,
        seriesCombinationVisibility,
      }) => {
        return {
          url: "SeriesCombinations/GetBySearch",
          params: {
            adm0Code: admCode,
            skip,
            take,
            query,
            marketId: market,
            commodityId: comodity,
            commodityUnitId,
            currencyId,
            priceTypeId,
            seriesCombinationVisibility,
          },
        }
      },
      providesTags: ["Series"],
    }),
    deleteSeries: builder.mutation<void, number>({
      query: id => ({
        url: `SeriesCombinations/Delete/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Series"],
    }),
    updateSeries: builder.mutation<
      { resultCode: number; resultMessage: string },
      Partial<SeriesCombination & { marketIDs: number[]; commodityIDs: number[] }>
    >({
      query: body => ({
        url: "SeriesCombinations/Put",
        method: "PUT",
        body,
        responseHandler: response => (response?.resultMessage ? response : response.text()),
      }),
      invalidatesTags: ["Series"],
    }),
    addSeriesCombination: builder.mutation<
      { resultCode: number; resultMessage: string },
      Partial<SeriesCombination & { marketIDs: number[]; commodityIDs: number[] }>
    >({
      query: body => ({
        url: "SeriesCombinations/Post",
        method: "POST",
        body,
        responseHandler: response => (response?.resultMessage ? response : response.text()),
      }),
      invalidatesTags: ["Series"],
    }),

    deleteMultipleSeries: builder.mutation<void, number[]>({
      query: ids => ({
        url: `SeriesCombinations/DeleteMultipleSeries`,
        method: "DELETE",
        body: ids,
      }),
      invalidatesTags: ["Series"],
    }),

    hideMultipleSeries: builder.mutation<void, { ids: number[]; isVisible: boolean }>({
      query: ({ ids, isVisible }) => ({
        url: `SeriesCombinations/BulkUpdateSeriesCombinationVisibility`,
        method: "POST",
        body: {
          seriesCombinationIds: ids,
          seriesCombinationVisibility: isVisible,
        },
      }),
      invalidatesTags: ["Series"],
    }),
  }),
})

export const {
  useGetSeriesCombinationQuery,
  useLazyGetSeriesCombinationQuery,
  useDeleteSeriesMutation,
  useUpdateSeriesMutation,
  useAddSeriesCombinationMutation,
  useDeleteMultipleSeriesMutation,
  useHideMultipleSeriesMutation,
} = seriesCombination
